import {
  FETCH_RESOURCE_REQUEST,
  FETCH_RESOURCE_SUCCESS,
  FETCH_RESOURCE_FAILURE
} from '../../actionTypes/resourceActionTypes'

const fetchResourceRequest = partNumber => {
  const action = {
    type: FETCH_RESOURCE_REQUEST,
    payload: partNumber
  }
  return action
}

const fetchResourceSuccess = data => {
  const action = {
    type: FETCH_RESOURCE_SUCCESS,
    payload: data
  }
  return action
}

const fetchResourceFailure = payload => {
  const action = {
    type: FETCH_RESOURCE_FAILURE,
    payload
  }
  return action
}

export { fetchResourceRequest, fetchResourceSuccess, fetchResourceFailure }
